// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sqaY\\+uuB{display:flex;max-width:100%}.sqaY\\+uuB .whSgjlwX{--color-primary:#07f;flex:1 1 auto;font-size:.88rem;min-width:0;text-align:center;width:auto;word-wrap:anywhere}@media(max-width:400px){.sqaY\\+uuB .whSgjlwX{font-size:.81rem;padding-left:.25rem;padding-right:.25rem}.sqaY\\+uuB .whSgjlwX>span{gap:.38rem}}.sqaY\\+uuB .whSgjlwX .C9dqCS-M{flex-shrink:0;font-size:1.5rem;margin-bottom:-.2rem;margin-top:-.2rem}.sqaY\\+uuB .eKJT7xi4{border-radius:.5rem;font-size:1rem}@media(max-width:400px){.sqaY\\+uuB .eKJT7xi4{font-size:.88rem}}.sqaY\\+uuB .eKJT7xi4 .C9dqCS-M{margin-bottom:-.13rem;margin-top:-.13rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"wrapper": "sqaY+uuB",
	"btn": "whSgjlwX",
	"logo": "C9dqCS-M",
	"btnLarge": "eKJT7xi4"
};
module.exports = ___CSS_LOADER_EXPORT___;
